/*
 * TFX Sticky ATC Footer Guard
 * Objective: hide sticky add-to-cart when the page footer enters the viewport.
 * Impacted pages: product templates rendering snippets/sticky-atc.liquid.
 * Dependencies: sticky-atc custom element, IntersectionObserver.
 * Date: 2026-03-11
 * Rollback: remove this file, its script tag in snippets/sticky-atc.liquid, and the CSS block in assets/tfx-effects.css.
 */
(function () {
  if (window.TFXStickyAtcFooterGuard) return;
  window.TFXStickyAtcFooterGuard = true;

  var instances = new WeakMap();

  function getFooterTarget() {
    return document.getElementById('pagefooter');
  }

  function updateHiddenState(stickyAtc, shouldHide) {
    if (!stickyAtc) return;
    stickyAtc.classList.toggle('tfx-sticky-atc--footer-hidden', Boolean(shouldHide));
  }

  function destroyStickyAtc(stickyAtc) {
    var instance = instances.get(stickyAtc);
    if (!instance) return;

    if (instance.observer) {
      instance.observer.disconnect();
    }

    if (instance.resizeHandler) {
      window.removeEventListener('resize', instance.resizeHandler);
    }

    updateHiddenState(stickyAtc, false);
    instances.delete(stickyAtc);
  }

  function createObserver(stickyAtc, footerTarget, instance) {
    if (instance.observer) {
      instance.observer.disconnect();
    }

    var stickyRect = stickyAtc.getBoundingClientRect();
    var stickyHeight = Math.max(Math.ceil(stickyRect.height || stickyAtc.offsetHeight || 0), 1);
    var overlapOffset = stickyHeight + 8;

    instance.observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].target !== footerTarget) continue;
        updateHiddenState(stickyAtc, entries[i].isIntersecting);
      }
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -' + overlapOffset + 'px 0px'
    });

    instance.observer.observe(footerTarget);
  }

  function initStickyAtc(stickyAtc) {
    if (!(stickyAtc instanceof Element) || instances.has(stickyAtc)) return;

    var footerTarget = getFooterTarget();
    if (!footerTarget || !('IntersectionObserver' in window)) return;

    var resizeFrameId = 0;
    var instance = {
      observer: null,
      resizeHandler: function () {
        if (resizeFrameId) {
          window.cancelAnimationFrame(resizeFrameId);
        }

        resizeFrameId = window.requestAnimationFrame(function () {
          resizeFrameId = 0;
          createObserver(stickyAtc, footerTarget, instance);
        });
      }
    };

    createObserver(stickyAtc, footerTarget, instance);
    window.addEventListener('resize', instance.resizeHandler);
    instances.set(stickyAtc, instance);
  }

  function initAll(scope) {
    var root = scope instanceof Element || scope instanceof Document ? scope : document;

    if (root instanceof Element && root.matches('sticky-atc')) {
      initStickyAtc(root);
    }

    var stickyAtcNodes = root.querySelectorAll ? root.querySelectorAll('sticky-atc') : [];
    for (var i = 0; i < stickyAtcNodes.length; i += 1) {
      initStickyAtc(stickyAtcNodes[i]);
    }
  }

  function destroyAll(scope) {
    var root = scope instanceof Element || scope instanceof Document ? scope : document;

    if (root instanceof Element && root.matches('sticky-atc')) {
      destroyStickyAtc(root);
    }

    var stickyAtcNodes = root.querySelectorAll ? root.querySelectorAll('sticky-atc') : [];
    for (var i = 0; i < stickyAtcNodes.length; i += 1) {
      destroyStickyAtc(stickyAtcNodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
